import { Directive, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[appErrImg]'
})
export class ErrImgDirective {
  @Input('appErrImg') public imgStr: string;
  public constructor() {}

  @HostListener('error', ['$event.target'])
  public imgError(event) {
    if (this.imgStr) {
      event.src = this.imgStr;
    } else {
      event.src = '/assets/icon/favicon.png';
    }
  }
}
